import clsx from "clsx";
import {
  GenericInfoPopup,
  Icon,
  IconName,
  getAgentErrorSubtitle,
  getAgentErrorTitle,
  useDeviceTypes,
} from "halifax";
import React, { useContext, useState } from "react";
import { RouteComponentProps } from "react-router";
import {
  ErrorType,
  MODAL_ALERT,
  MODAL_ALERT_CHOICE,
  ModalAlertProperties,
  ModalButtonType,
  ModalCategoryType,
  ModalScreens,
} from "redmond";

import { ClientContext } from "../../../../App";
import { trackEvent } from "../../../../api/v0/analytics/trackEvent";
import { PATH_HOME, PATH_HOME_STAYS } from "../../../../utils/paths";
import { AvailabilityErrorModalConnectorProps } from "./container";
import "./styles.scss";
import * as textConstants from "./textConstants";
import {
  AVAILABLE,
  getExperimentVariant,
  STAYS_SEARCH,
  useExperiments,
} from "../../../../context/experiments";

export interface IAvailabilityErrorModalProps
  extends AvailabilityErrorModalConnectorProps,
    RouteComponentProps {}

export const AvailabilityErrorModal = (props: IAvailabilityErrorModalProps) => {
  const { hasFailed, history, fetchInitialHotelAvailability } = props;
  const { isAgentPortal } = useContext(ClientContext);
  const { matchesMobile } = useDeviceTypes();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const expState = useExperiments();

  const staysSearchEnabled =
    getExperimentVariant(expState.experiments, STAYS_SEARCH) === AVAILABLE;

  const modalEventProperties: ModalAlertProperties = {
    lob: "hotel",
    type: "hotels_availabiltity_error",
    primary_button: textConstants.SEARCH_AGAIN_BUTTON,
    secondary_button: textConstants.GO_BACK_BUTTON,
    screen: ModalScreens.HOTELS_AVAILABILITY,
    category: ModalCategoryType.TROUBLE,
    modal_subtitle: textConstants.AVAILABILITY_ERROR_SUBTITLE,
    modal_title: textConstants.AVAILABILITY_ERROR_TITLE,
    agent_title: getAgentErrorTitle(ErrorType.NoAvailability),
    agent_subtitle: getAgentErrorSubtitle(ErrorType.NoAvailability),
    funnel: "hotels",
    step: "availability",
  };
  React.useEffect(() => {
    if (hasFailed) {
      setIsOpen(true);
      trackEvent({
        eventName: MODAL_ALERT,
        properties: { ...modalEventProperties },
      });
    }
  }, [hasFailed]);

  const buttons = [
    {
      buttonText: textConstants.GO_BACK_BUTTON,
      buttonWrapperClassName: clsx(
        "availability-error-modal-button",
        "secondary"
      ),
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT_CHOICE,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.SECONDARY,
          },
        });

        const path = staysSearchEnabled ? PATH_HOME_STAYS : PATH_HOME;
        history.push(path);
      },
    },
    {
      buttonText: textConstants.SEARCH_AGAIN_BUTTON,
      buttonWrapperClassName: clsx(
        "availability-error-modal-button",
        "primary"
      ),
      onClick: () => {
        setIsOpen(false);
        trackEvent({
          eventName: MODAL_ALERT_CHOICE,
          properties: {
            ...modalEventProperties,
            button_choice: ModalButtonType.PRIMARY,
          },
        });
        fetchInitialHotelAvailability({
          history: history,
          searchFromMap: false,
          searchHotelsNear: false,
          includeHomes: staysSearchEnabled,
        });
      },
    },
  ];

  return (
    <GenericInfoPopup
      agentSubtitle={getAgentErrorSubtitle(ErrorType.NoAvailability)}
      agentTitle={getAgentErrorTitle(ErrorType.NoAvailability)}
      buttons={buttons}
      className="hotel-availability-error-modal-root"
      image={<Icon className="error-icon" name={IconName.ErrorState} />}
      isAgent={isAgentPortal}
      isMobile={matchesMobile}
      open={isOpen}
      subtitle={textConstants.AVAILABILITY_ERROR_SUBTITLE}
      title={textConstants.AVAILABILITY_ERROR_TITLE}
    />
  );
};
